import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { InputRenderer } from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import Regex from "src/shared/forms/validations/Regex";
import { required as Required } from "src/shared/forms/validations/Required";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface IMerchantNameInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  maxLength?: number;
}

export const MerchantNameInput = ({
  inputID,
  label = <FormattedMessage id="merchants.name" />,
  validationDisabled = false,
  maxLength = 64,
  ...rest
}: IMerchantNameInputProps) => {
  const validations = useMemo<ValidationHandler[] | undefined>(() => {
    if (validationDisabled) {
      return undefined;
    }
    return [
      Required,
      Length(3, maxLength),
      Regex(
        /^[\p{L}\p{M}*+0-9 &\-_\.,'\/\\"]+$/u,
        <FormattedMessage id="form.validations.name.invalid" />,
      ),
    ];
  }, [validationDisabled, maxLength]);
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
